module.exports = __webpack_public_path__ + "static/DS_baptism-8881e3ad70247c39519d5ae25c95be13.jpg";